/**
 * Offres coach (entité Product) — extensible (program / online plus tard).
 * Référencées par client.productId + client.productInstance.
 */

import { DEMO_PRODUCT_IDS } from "./demoEntityIds";

export { DEMO_PRODUCT_IDS };

export const INIT_PRODUCTS = [
  {
    id: DEMO_PRODUCT_IDS.session,
    name: "Séance à l'unité",
    type: "session",
    pricing: {
      amount: 60,
      perSession: 60,
      recurrence: null,
    },
    sessions: {
      count: 1,
      validityDays: null,
    },
    deliveryMode: "in_person",
    description: "Une séance facturée individuellement.",
    isActive: true,
    createdAt: "2026-03-20",
  },
  {
    id: DEMO_PRODUCT_IDS.pack,
    name: "Pack 10 séances",
    type: "pack",
    pricing: {
      amount: 500,
      perSession: 50,
      recurrence: null,
    },
    sessions: {
      count: 10,
      validityDays: 90,
      packValidityStart: "first_session",
    },
    deliveryMode: "in_person",
    description: "10 séances, validité 3 mois.",
    isActive: true,
    createdAt: "2026-03-20",
  },
  {
    id: DEMO_PRODUCT_IDS.subscription,
    name: "Suivi mensuel",
    type: "subscription",
    pricing: {
      amount: 250,
      perSession: null,
      recurrence: "monthly",
    },
    sessions: {
      count: 4,
      validityDays: null,
    },
    subscription: {
      maintainByDefaultOnStandby: false,
      standbyBillingMode: "full_month",
    },
    deliveryMode: "in_person",
    description: "Forfait mensuel — 4 séances incluses.",
    isActive: true,
    createdAt: "2026-03-20",
  },
  {
    id: DEMO_PRODUCT_IDS.programme,
    name: "Remise en forme 12 semaines",
    type: "program",
    pricing: {
      amount: 480,
      perSession: 60,
      recurrence: null,
    },
    sessions: {
      count: 8,
      validityDays: 84,
    },
    paymentSchedule: "once",
    durationWeeks: 12,
    deliveryMode: "in_person",
    description: "8 séances sur 12 semaines — prix forfaitaire.",
    isActive: true,
    createdAt: "2026-03-20",
  },
];

export const PRODUCT_TYPES = ["session", "pack", "subscription", "program"];
